import { makeStyles } from "@material-ui/core/styles";
import { blue } from "@material-ui/core/colors";

export const baseWindowStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
    [theme.breakpoints.up("md")]: {
      justifyContent: "center",
      display: "flex",
      paddingTop: "3%",
      height: "auto",
    },
  },
  paper: {
    minHeight: "100vh",
    padding: "10px",

    [theme.breakpoints.up("md")]: {
      padding: "20px",
      width: "800px",
      minHeight: "50vh",
    },
  },
  baseGrid: {
    paddingLeft: 20,
    paddingRight: 20,
    [theme.breakpoints.up("md")]: {
      width: "80%!important",
    },
  },
  baseGridWhBasket: {
    paddingLeft: 20,
    paddingRight: 20,
  },
  basket: {
    backgroundImage: "linear-gradient(339deg,#84bd00 -10%,#0057B7 35%)",
    width: "auto",
    color: "whitesmoke!important",
    padding: "15px 25px 55px 25px",

    [theme.breakpoints.up("md")]: {
      position: "absolute",
      width: "240px",
      top: "-50px",
      bottom: "auto",
      right: "-160px",
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      borderBottomLeftRadius: "50px!important",
      borderBottomRightRadius: "50px!important",
    },
  },
  basketHeader: {
    fontSize: "16px",
    fontWeight: "600",
    fontFamily: "ProximanovaSemibold",
    marginBottom: 0,
  },
  basketHeaderBottom: {
    fontSize: 13,
    color: "#fff",
    opacity: 0.7,
    marginbottom: 0,
    margintop: 4,
  },
  basketAmountTitle: {
    fontSize: "14px",
    fontWeight: "500",
  },
  basketAmount: {
    fontSize: "28px",
    fontWeight: "600",
    marginTop: 4,
    whiteSpace: "nowrap",
    lineHeight: 1,
  },
  basketSup: {
    fontSize: "13px",
    fontWeight: "400",
  },
  basketContentTitle: {
    float: "left",
    fontSize: "13px",
    opacity: 0.5,
    fontWeight: 700,
    lineHeight: 1.86,
    fontFamily: "SommetRoundedLight!important",
  },
  basketContentValue: {
    float: "right",
    textAlign: "right",
    fontSize: "14px",
    lineHeight: 1.63,
    fontFamily: "SommetRoundedLight!important",
  },
  basketContentSubTitle: {
    float: "left",
    fontSize: "11px",
    marginLeft:"8px",
    opacity: 0.5,
    fontWeight: 600,
    lineHeight: 1.86,
    fontFamily: "SommetRoundedLight!important",
  },
  basketContentSubValue: {
    float: "right",
    textAlign: "right",
    fontSize: "12px",
    lineHeight: 1.63,
    fontFamily: "SommetRoundedLight!important",
  },
  basketCountDown: {
    position: "absolute",
    right: "15px",
    fontSize: "16px",
    fontWeight: "600",
    fontFamily: "SommetRoundedLight",
  },
  divider: {
    marginTop: "15px!important",
    marginBottom: "15px!important",
    backgroundColor: "#fff!important",
    opacity: "0.3!important",
    height: "0.5px!important",
  },
}));

export const inputStyles = makeStyles((theme) => ({
  otpInput: {
    textAlign: "center",
    fontSize: "20px!important",
  },
  noBorder: {
    border: "none",
  },
  box: {
    widht: "100%",
    height: "100%",
    padding: "5px 20px",
  },
  header: {
    fontSize: "15px",
    fontWeight: "500",
    fontFamily: "SommetRoundedRegular",
  },
  p: {
    fontSize: "14px",
    fontWeight: "300!important",
    fontFamily: "SommetRoundedRegular",
  },
  pBold: {
    fontSize: "15px",
    fontWeight: "600",
    fontFamily: "SommetRoundedRegular",
    textAlign: "center",
    width: "100%",
  },
  pDocument: {
    fontSize: "1rem",
    fontWeight: "400",
    fontFamily: "SommetRoundedLight",
    textIndent: "20px",
  },
  label: {
    fontSize: "13px!important",
    fontFamily: "SommetRoundedLight!important",
  },
  button: {
    textTransform: "none!important",
    marginRight: "10px!important",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      marginRight: "0!important",
      marginBottom: "10px!important",
    },
  },
  radioLabel: {
    padding: "5px 12px 5px 0",
    border: "solid 1px " + blue[200],
    borderRadius: 3,
    marginLeft: 0,
  },
  textField: {
    width: "100%",
    fontFamily: "SommetRoundedLight!important",
    fontWeight: "400!important",
    fontStyle: "normal!important",
    fontSize: "16px!important",
  },
  transactionAmountBox: {
    background:
      "linear-gradient(175deg, rgba(34,78,195,1) 53%, rgba(36,201,41,1) 100%)",
    borderBottomLeftRadius: 15,
    borderBottomRightRadius: 15,
    textAlign: "center",
    paddingBottom: 15,
    paddingTop: 15,
    marginTop: 10,
    color: "whitesmoke",
  },
  informationLabel: {
    fontSize: 12,
    fontWeight: "300",
    fontFamily: "SommetRoundedLight!important",
  },
}));

export const alertStyles = makeStyles((theme) => ({
  root: {
    width: "inherit",
    position: "absolute",
    bottom: 10,

    "& > * + *": {
      marginBottom: theme.spacing(2),
    },
  },
}));

export const loadingStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 999999999 + "!important",
    color: "#fff",
  },
}));

export const countDownStyles = makeStyles((theme) => ({
  countDown: {
    color: theme.palette.primary.light,
    fontSize: "22px",
    fontWeight: "400",
    marginLeft: 10,
    lineHeight: 1.8,
    display:'flex',
    alignItems:'center'
  }
}));

export const usePlatformWaitingStyles = makeStyles(() => ({
  title: {
    fontSize: "clamp(20px, 4vw, 28px)",
    fontWeight: "bold",
    color: "#0057B8",
    marginBottom: "10px",
    textAlign: "left",
    fontFamily: "SommetRoundedRegular"
  },
  description: {
    fontSize: "16px",
    color: "#333333",
    textAlign: "left",
    fontFamily: "SommetRoundedRegular"
  },
  limitInfo: {
    fontSize: "14px",
    color: "#333333",
    marginTop: "10px",
    textAlign: "left",
    fontFamily: "SommetRoundedRegular"
  },
  infoText: {
    fontSize: "16px",
    fontWeight: "bold",
    color: "#333",
    marginBottom: "10px",
    marginLeft: "10px",
    marginTop: "5px",
    textAlign: "left",
    fontFamily: "SommetRoundedRegular"
  },
  list: {
    fontSize: "14px",
    color: "#7A7A7A",
    textAlign: "left",
    marginTop: "10px",
    fontFamily: "SommetRoundedRegular"
  },
  greyBox: {
    backgroundColor: "#F4F4F4",
    padding: "10px 0px",
    borderRadius: "8px",
    width: "100%",
    marginBottom: "30px",
  },
  redirectText: {
    fontSize: "16px",
    color: "#333333",
    marginTop: "20px",
    textAlign: "center",
    fontFamily: "SommetRoundedRegular"
  },
  circle: {
    position: "relative",
    width: "120px",
    height: "120px",
    margin: "0 auto",
  },
  svg: {
    transform: "rotate(-90deg)",
    width: "100%",
    height: "100%",
  },
  textContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    fontFamily: "SommetRoundedRegular"
  },
  countdownText: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#333",
    display: "block",
    fontFamily: "SommetRoundedRegular"
  },
  saniyeText: {
    fontSize: "14px",
    fontWeight: "normal",
    color: "#333",
    fontFamily: "SommetRoundedRegular"
  },
}));
